import Promise from 'bluebird';
Promise.config({ cancellation: true });

import { POI_CATEGORIES } from '@/helpers/here';
import { WaypointCategory, ChargingStationCategory } from '@/helpers/constants';

import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';

import {
    FETCH_POI,
    FETCH_CHARGING_STATIONS,
    FETCH_HARLEY,
    CLEAR_POI,
    SET_ENABLED,
    SET_POI_CATEGORY,
    SET_DISABLED_CATEGORIES,
    SET_CHARGING_STATION,
    SET_CHARGING_STATIONS
} from '@/store/actions/poi';

const initialState = {
    // the poi data
    points: [],

    // events and dealers
    harley: [],

    cs: [],

    // the center of the last fetched POIS
    lastCoords: null,

    // Whether or not POIs are enabled
    enabled: true,

    // Map of disabled Waypoint categories
    disabledCategories: {
        [WaypointCategory.GAS_STATION]: true,
        [WaypointCategory.SCENIC]: true,
        [WaypointCategory.RESTAURANT]: true,
        [WaypointCategory.HOTEL]: true,
        [WaypointCategory.DEALER]: false,
        [WaypointCategory.EVENT]: true
    },

    // Map of disabled Waypoint categories
    chargingStations: {
        [ChargingStationCategory.LEVEL_1]: false,
        [ChargingStationCategory.LEVEL_2]: false,
        [ChargingStationCategory.LEVEL_3]: false,
        [ChargingStationCategory.CHARGEPOINT]: false,
        [ChargingStationCategory.ELECTRIFY_AMERICA]: false,
        [ChargingStationCategory.INNOGY]: false,
        [ChargingStationCategory.OTHER_NETWORK]: false
    },

    // here POI categories to search over
    poiCategories: [
        POI_CATEGORIES.PETROL_STATION,
        POI_CATEGORIES.EAT_DRINK,
        POI_CATEGORIES.NATURAL_GEOGRAPHICAL,
        POI_CATEGORIES.LEISURE_OUTDOOR,
        POI_CATEGORIES.HOTEL
    ]
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_POI: {
            const { points, coords } = action.data;
            return { ...state, points, lastCoords: coords };
        }

        case FETCH_CHARGING_STATIONS: {
            const { points, coords } = action.data;
            return { ...state, cs: points, lastCoords: coords };
        }

        case FETCH_HARLEY: {
            const { points } = action.data;
            return { ...state, harley: points };
        }

        case CLEAR_POI: {
            const { enabled } = state;
            return { ...state, ...initialState, enabled };
        }

        case SET_ENABLED: {
            const { enabled } = action.data;
            return { ...state, enabled };
        }

        case SET_POI_CATEGORY: {
            const { category, enabled } = action.data;
            return {
                ...state,
                disabledCategories: {
                    ...state.disabledCategories,
                    [category]: !enabled
                }
            };
        }

        case SET_CHARGING_STATION: {
            const { category, enabled } = action.data;
            return {
                ...state,
                chargingStations: {
                    ...state.chargingStations,
                    [category]: !enabled
                }
            };
        }

        case SET_DISABLED_CATEGORIES: {
            const { disabled } = action.data;

            return {
                ...state,
                disabledCategories: {
                    ...initialState.disabledCategories,
                    ...disabled
                }
            };
        }

        case SET_CHARGING_STATIONS: {
            const { disabled } = action.data;

            return {
                ...state,
                chargingStations: {
                    ...initialState.chargingStations,
                    ...disabled
                }
            };
        }

        case AUTH_INVALIDATE:
        default: {
            return state;
        }
    }
};
